import { render } from "./Tabs.vue?vue&type=template&id=0e1483d4&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=0e1483d4&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/dev-mdstar-client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1483d4"]])

export default __exports__